import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/examples/code-block/code-block.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
